import UI from "./components/ui/UI";
import Scene from "./components/scene/Scene";
import { Leva } from "leva";
import { useEffect, useRef, useState } from "react";
import { useStore } from "./components/store";
import { load } from "js-yaml";

export default function App() {
  const setMembers = useStore((state) => state.setMembers);

  // loading
  useEffect(() => {
    fetch("members.yaml")
      .then((r) => r.text())
      .then((text) => {
        let _members = load(text);
        const updatedMembers = _members.map((member, i) => {
          member.num = i;
          return member;
        });
        setMembers(updatedMembers);
      });
  }, []);

  return (
    <div className={"w-screen h-screen"} style={{ height: "inherit" }}>
      <Scene />
      <UI />
      <Leva hidden />
    </div>
  );
}
